import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { ExportCSVReport } from 'utils/createCSVReportFile';

import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { deleteWorkOrderChange } from '../WorkOrderChangeQueries';

export const useRemoveWorkOrderChange = ({ refreshProject }: { refreshProject: () => void }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [confirmationDialogOpened, setConfirmationDialogOpened] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [hasError, setHasError] = useState(false);
    const [currentIdForDelete, setCurrentIdForDelete] = useState(null);

    const openConfirmationDialogHandler = useCallback((id) => {
        setCurrentIdForDelete(id);
        setConfirmationDialogOpened(true);
    }, []);

    const [
        deleteWorkOrderChangeData,
        deleteWorkOrderChangeStatus,
        deleteWorkOrderChangeErr,
        deleteWorkOrderChangeRequest,
    ] = useRequest({
        requestId: 'deleteWorkOrderChange',
        query: deleteWorkOrderChange,
        withEffect: false,
    });
    const [resetDeleteData] = useResetStoreData({ requestId: 'deleteWorkOrderChange' });

    const submitDeleteHandler = useCallback(() => {
        setIsSubmitted(true);
        dispatch(deleteWorkOrderChangeRequest({ workOrderChangeId: Number(currentIdForDelete) }));
    }, [currentIdForDelete, deleteWorkOrderChangeRequest, dispatch]);

    const cancelDeleteHandler = useCallback(() => {
        setConfirmationDialogOpened(false);
    }, []);

    const closeErrorModalHandler = useCallback(() => {
        setHasError(false);
        resetDeleteData(null);
    }, [resetDeleteData]);

    const createErrorReportHandler = useCallback(() => {
        ExportCSVReport(deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.validation);
    }, [deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.validation]);

    useEffect(() => {
        if (isSubmitted && deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.result) {
            setIsSubmitted(false);
            refreshProject?.();
            resetDeleteData(null);
        }
        if (
            isSubmitted &&
            (deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.message ||
                deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.validation?.length)
        ) {
            setHasError(true);
        }
    }, [
        deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.message,
        deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.result,
        deleteWorkOrderChangeData?.uerDeleteWorkOrderChange?.validation?.length,
        isSubmitted,
        navigate,
        refreshProject,
        resetDeleteData,
    ]);

    return {
        confirmationDialogOpened,
        openConfirmationDialogHandler,
        submitDeleteHandler,
        cancelDeleteHandler,
        hasError,
        deleteWorkOrderChangeData,
        deleteWorkOrderChangeStatus,
        deleteWorkOrderChangeErr,
        closeErrorModalHandler,
        createErrorReportHandler,
    };
};
